import { MouseEvent, ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';
import { RemoveIcon } from '@ui/icons/RemoveIcon';

import styles from './Badge.module.css';

export type Props = {
  size?: 'm' | 'l' | 'h25' | 's' | 'xs';
  flat?: boolean;
  className?: string;
  title?: string;
  href?: string;
  download?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  removeTitle?: string;
  highlighted?: boolean;
  children: ReactNode;
};
export function Badge({
  className,
  title,
  flat,
  children,
  href,
  download,
  onClick,
  onRemove,
  removeTitle,
  highlighted,
  size = 'm',
}: Props) {
  const handleRemove = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove?.();
  };

  const badge = (
    <span
      title={title}
      onClick={onClick}
      className={cx(className, styles.badge, styles[size], {
        [styles.flat]: flat,
        [styles.link]: !!href || onClick,
        [styles.highlighted]: highlighted,
      })}
    >
      {children}

      {onRemove && (
        <button
          type="button"
          title={removeTitle}
          aria-label={removeTitle ?? 'Удалить'}
          onClick={handleRemove}
          className={styles.remove_btn}
        >
          <RemoveIcon className={styles.remove_btn__icon} />
        </button>
      )}
    </span>
  );

  if (!href) return badge;

  return (
    <Link title={title} target="_blank" to={href} download={download} onClick={onClick}>
      {badge}
    </Link>
  );
}
